(function ($) {
    $(document).ready(function () {
        var $toggleContentLink = $(".toggle-content"),
            $addCloseButton = $(".add-close-button"),
            $toggleContentClose = $(".toggle-content__close"),
            $toggleContentTarget = $(".toggle-content__target");

        // if ( $toggleContentClose.length > 0) {

        // }

        if ($addCloseButton.length > 0) {
            $toggleContentLink
                .next($toggleContentTarget)
                .append(
                    '<button class="toggle-content__close button"><i class="material-icons">close</i></button>'
                );
        }

        if ($toggleContentLink.length > 0) {
            $toggleContentLink.on("click", function (event) {
                event.preventDefault();
                $(this).next($toggleContentTarget).slideToggle("fast");

                $("body").on(
                    "click",
                    ".toggle-content__close",
                    function (event) {
                        event.preventDefault();
                        $(this).parent().slideUp("fast");
                    }
                );
            });
        }
    });
})(jQuery);
